module.exports = {
  theme: {
    colors: {
      primary: '#04c777',
      secondary: '#273857',
      first: '#000000',
      twentieth: '#041f3b',
    },
  },
};
